import { render, staticRenderFns } from "./SelectView.vue?vue&type=template&id=c5bf8ccc&scoped=true&"
import script from "./SelectView.vue?vue&type=script&lang=js&"
export * from "./SelectView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5bf8ccc",
  null
  
)

export default component.exports